import { styled } from 'styled-components';
import { breakpoints, calcWidthOfColumns, colors, createTransition, dontForwardProps, Button, Text } from '@soluto-private/mx-asurion-ui-react';
export const Overlay = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1tqttnc-0"
})(["background:rgba(0,0,0,0.5);position:fixed;top:0;left:0;right:0;bottom:0;opacity:", ";", " display:flex;visibility:", ";pointer-events:", ";justify-content:center;align-items:center;z-index:999999999;"], ({
  isOpen
}) => isOpen ? 1 : 0, createTransition({
  properties: ['opacity', 'visibility']
}), ({
  isOpen
}) => isOpen ? 'visible' : 'hidden', ({
  isOpen
}) => isOpen ? 'auto' : 'none');
export const ModalContainer = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1tqttnc-1"
})(["background:", ";position:relative;display:flex;flex-direction:column;border-radius:1rem;min-height:20rem;max-height:80%;width:calc(100% - 2rem);overflow-y:", ";overflow-x:hidden;overflow-wrap:break-word;", "{max-height:60%;width:", ";}", "{width:", ";}", "{width:", ";}", "{width:", ";}@media (max-height:320px){min-height:100%;height:100%;overflow:scroll;}"], colors.white, ({
  isSticky
}) => isSticky ? 'clip' : 'auto', breakpoints.md, calcWidthOfColumns({
  columns: 8,
  totalColumns: 12,
  margin: 24,
  gutter: 16
}), breakpoints.lg, calcWidthOfColumns({
  columns: 6,
  totalColumns: 12,
  margin: 24,
  gutter: 16
}), breakpoints.xl, calcWidthOfColumns({
  columns: 6,
  totalColumns: 12,
  margin: 48,
  gutter: 16
}), breakpoints.xxl, calcWidthOfColumns({
  columns: 6,
  totalColumns: 12,
  margin: 0,
  gutter: 16,
  maxWidth: '113.9375rem'
}));
export const Header = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1tqttnc-2"
})(["flex-shrink:0;", ");"], ({
  heroImage
}) => heroImage ? `
  height: 14rem;
  background: center/cover url(${heroImage});
  padding: 0;
  ` : `
  padding: 1rem 4rem 0 1rem;

  ${breakpoints.md} {
    padding: 1.5rem 4.5rem 0 1.5rem;
  }
  `);
export const Content = styled.div.withConfig({
  componentId: "aui__sc-1tqttnc-3"
})(["flex:1;padding:1rem;overflow-y:auto;overflow-x:hidden;overflow-wrap:break-word;"]);
export const Title = styled(Text).attrs({
  size: 4,
  weight: 'base',
  forwardedAs: 'h2'
}).withConfig({
  componentId: "aui__sc-1tqttnc-4"
})(["margin-bottom:0.5rem;"]);
export const Subtitle = styled(Text).attrs({
  size: 1,
  weight: 'base',
  forwardedAs: 'p'
}).withConfig({
  componentId: "aui__sc-1tqttnc-5"
})(["color:", ";"], colors.neutralDeeper);
export const DismissButton = styled(Button).attrs({
  ariaLabel: 'Dismiss modal',
  iconSrc: 'close-x',
  color: 'white'
}).withConfig({
  componentId: "aui__sc-1tqttnc-6"
})(["position:absolute;top:0.5rem;right:0.5rem;padding:0.5rem;border:0.0625rem solid ", ";&:disabled,&:not(:disabled):hover{border-color:", ";}"], colors.neutralBright, colors.neutralBright);